import { Grid, IconButton, MenuItem, Popover, Typography } from '@mui/material';
import VerticalDotsIcon from 'assets/icons/buttons/table-dots.svg';
import { useState } from 'react';
import { styles } from './styles';
import { ICommentActionsPopover } from './types';

export const CommentActionsPopover = ({ items }: ICommentActionsPopover) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'post-item-modal-post-header-popover' : undefined;

  return (
    <Grid>
      <IconButton sx={styles.btn} onClick={handleClick}>
        <VerticalDotsIcon />
      </IconButton>
      <Popover
        id={id}
        sx={styles.popover}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        transitionDuration={{ appear: 300, enter: 300, exit: 10 }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {items.map(({ label, Icon, onClick }) => (
          <MenuItem key={label} onClick={onClick} sx={styles.menuItem}>
            <Icon />
            <Typography sx={styles.label}>{label}</Typography>
          </MenuItem>
        ))}
      </Popover>
    </Grid>
  );
};
